// import libraries
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
// import constants
import { NOT_FOUND_TITLE, NOT_FOUND_SUBTITLE, NOT_FOUND_MESSAGE } from './constant';
// import styling
import './NotFound.css';

const NotFound = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
    });
    return () => unsub();
  }, []);

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">{NOT_FOUND_TITLE}</h1>
        <h2 className="not-found-subtitle">{NOT_FOUND_SUBTITLE}</h2>
        <p className="not-found-message">{NOT_FOUND_MESSAGE}</p>
        <div className="not-found-actions">
          {isAuthenticated ? (
            <Link to="/dashboard" className="btn-primary">Go to Dashboard</Link>
          ) : (
            <Link to="/" className="btn-secondary">Go to Home</Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
